<template>
    <div>
        <rkm-row
            v-for="(par, index) in procedimentosPareados"
            :key="index"
        >
            <template v-for="procedimento in par">
                <rkm-col
                    cols="1"
                    :key="`${procedimento.campo}-quantidade`"
                >
                    <rkm-form-input
                        number
                        name="Quantidade"
                        :validations="getValidations(procedimento)"
                        v-model="model.procedimentosQuantidade[campoCamel(procedimento)]"
                    />
                </rkm-col>

                <rkm-col
                    cols="5"
                    :key="`${procedimento.campo}-nome`"
                >
                    {{ procedimento.nome }}
                </rkm-col>
            </template>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import {stringCase} from '@/mixins'

export default {
    computed: {
        procedimentosPareados() {
            const pares = []

            for (let i = 0; i < this.form.procedimentos.length; i += 2) {
                pares.push(this.form.procedimentos.slice(i, i + 2))
            }

            return pares
        },
    },
    methods: {
        campoCamel(procedimento) {
            return this.snakeToCamel(procedimento.campo)
        },
        getValidations(procedimento) {
            return this.model.procedimentosQuantidade[this.campoCamel(procedimento)] === ''
                ? null
                : {max_value: procedimento.quantidadeMaxima}
        },
    },
    mixins: [stringCase],
    props: {
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
}
</script>
